import type { FC, ReactNode } from 'react';
import { Box, Typography } from '@mui/material';

import { styles } from '../ticketDetail.styles';

const TicketDetailBox: FC<{ label: ReactNode; value: ReactNode }> = ({
  label,
  value,
}) => (
  <Box sx={styles.ticketDetailBox}>
    <Typography variant="body3">{label}</Typography>
    <Typography sx={styles.ticketDetailBoxValue}>{value}</Typography>
  </Box>
);

export default TicketDetailBox;
